const FacetSearchUserListSlice = {
  lists: [],
  selected: null,
  userCanSeeLists: false,
};

window.FacetSearchUserListSlice = FacetSearchUserListSlice
export { FacetSearchUserListSlice }
